<template>
    <div class="subscription--inner">
        <div class="subscription--inner-wrap" v-if="data">
            <h3>{{ data.title }}</h3>
            
            <div class="text-grid">
                <div class="text-content" v-html="data.content" />
            </div>

            <div class="summary-grid" v-if="data.summary.length">
                <dl>
                    <div
                        v-for="(summary, index) in data.summary"
                        :data-recap="slugify(summary.summary_title)"
                        :key="index">
                        <dt>{{ summary.summary_title }}</dt>
                        <dd>{{ summary.summary_value }}</dd>
                    </div>
                </dl>
            </div>

            <div class="cta-grid" v-if="data.cta && data.cta.length">
                <a
                    class="btn btn-outlined"
                    v-for="(cta, index) in data.cta"
                    :key="index"
                    :href="cta.content_link.url"
                    :target="cta.content_link.target"
                    >
                    {{ cta.content_link.title }}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import slugify from 'slugify'

export default {
    name: 'SubscriptionScreenText',

    props: {
        data: Object
    },

    methods: {
        slugify (string) {
            return slugify(
                string,
                {
                    replacement: '-',
                    locale: 'fr',
                    trim: true
                }
            ).toLowerCase()
        }
    }
}
</script>